<div class="flex justify-center items-center h-full">
  <span class="text-lg font-semibold animate-pulse" i18n>{{
    displayText
  }}</span>
</div>
